import React from 'react';
import { useQuery } from '@apollo/client';

import Link from '@buyside/components/presentation/Link/link';
import LoadingSpinner from '@buyside/components/presentation/LoadingSpinner/loadingSpinner';
import RankingActions from './RankingActions/rankingActions';
import RankingMiniCardSection from './RankingMiniCardSection/rankingMiniCardSection';
import RankingProfileSection from './RankingProfileSection/rankingProfileSection';
import RankingUserSection from './RankingUserSection/rankingUserSection';

import UpArrow from '@buyside/svgs/up_arrow.svg';

import { userIdeaUrl } from '@buyside/util/urlHelper';
import {
  FeedRankQuery as FeedRankQueryData,
  FeedRankQueryVariables
} from '@interfaces/graphql-typings';
import { FeedItemComponentType } from '@interfaces/feed/feedItems';

const FeedRankQuery = require('buyside/graphql/queries/FeedRank');

import styles from './rankingStyles.scss';

const Ranking: React.FC<FeedItemComponentType> = ({ feedItemId }) => {
  const { data, loading, error } = useQuery<FeedRankQueryData, FeedRankQueryVariables>(
    FeedRankQuery,
    { variables: { feedItemId } }
  );

  if (error) throw error;

  if (loading) {
    return (
      <div className={styles.loading}>
        <LoadingSpinner type="secondary" />
      </div>
    );
  }

  const rank = data?.biggestMoverRank;
  const currentUser = data?.currentUser;

  if (!rank) return null;

  const { category, value, user } = rank;

  const generateRankUserLinkText = (): string =>
    `View all ${user?.publishedIdeasCount} of ${
      currentUser?.canViewUserDetails ? user?.displayName.split(' ')[0] : 'this user'
    }'s idea${user?.publishedIdeasCount && user?.publishedIdeasCount > 1 ? 's' : ''}`;

  return (
    <div className={styles.rankingFeedItem}>
      <div className={styles.cardMainArea}>
        <div className={styles.rankingRow}>
          <RankingProfileSection
            canViewUserDetails={Boolean(currentUser?.canViewUserDetails)}
            category={category}
            user={user}
            value={value}
          />
          <RankingUserSection
            canViewUserDetails={Boolean(currentUser?.canViewUserDetails)}
            category={category}
            user={user}
            value={value}
          />
        </div>
        <div className={styles.rankingRow}>
          <RankingActions
            canMessage={Boolean(currentUser?.canViewUserDetails && currentUser?.canManageMessages)}
            userId={user?.id}
          />
          <div>
            <RankingMiniCardSection user={user} />
            {user?.id && (
              <Link to={userIdeaUrl(user?.id)} className={styles.viewIdeasLink}>
                {generateRankUserLinkText()}
              </Link>
            )}
          </div>
        </div>
      </div>
      <UpArrow className={styles.backgroundArrow} />
    </div>
  );
};

export default Ranking;
